import {
  GET_NEW_IMAGE_REQUEST,
  SET_UPLOAD_IMAGE,
  SAVE_UPLOAD_IMAGE,
  GET_LOADING_IMAGE,
  UPLOAD_IMAGE_REQUEST,
  SET_TEMP_IMG,
  DELETE_IMAGE,
  SET_FILE,
  RESET_UPLOAD_IMAGE_STATE,
} from './constants';

export function getNewImageRequest(filename) {
  return { type: GET_NEW_IMAGE_REQUEST, payload: { filename } };
}

export function setUploadImage(filename) {
  return { type: SET_UPLOAD_IMAGE, payload: { filename } };
}

export function saveUploadImage(filename) {
  return { type: SAVE_UPLOAD_IMAGE, payload: { filename } };
}

export function getLoadingImage() {
  return { type: GET_LOADING_IMAGE, payload: {} };
}

export function uploadImageRequest(file) {
  return { type: UPLOAD_IMAGE_REQUEST, payload: { file } };
}

export function setTemporaryImage(data) {
  return { type: SET_TEMP_IMG, payload: { tempFileUrl: data } };
}

export function deleteImage(deleted) {
  return { type: DELETE_IMAGE, payload: { deleted } };
}

export function setFile(file) {
  return { type: SET_FILE, payload: { file } };
}

export function resetUploadImage() {
  return { type: RESET_UPLOAD_IMAGE_STATE };
}
